class DdpBtn {

    constructor(swiper) {
        this.ddpBtn           = document.getElementById('btn-ddp-marking-ce');
        this.backProvider     = document.getElementById('back-provider');
        this.btnCe            = document.getElementById('btn-ce');
        this.mySwiperVertical = document.querySelector('main > .swiper-container').swiper;
        this.header           = document.getElementById('header');
        this.swiper           = swiper;

        this.ddpBtn.addEventListener('click', () => {
            this.backProvider.click();
            setTimeout(() => {
                this.mySwiperVertical.slideTo(5, 0, false);
                    this.btnCe.click();
                setTimeout(() => {
                }, 500);
            }, 500);
        });
    }
}